import { Container } from '@/legacy/components/Container'
import { Media } from '@/legacy/components/Media'

interface Props {
  src: string
  alt: string
  width: number
  height: number
}

const BlogImageBlock = ({ src, alt, width, height }: Props) => (
  <Container spaceOut="m" spaceIn="s">
    <Media
      image={{ url: src, alt }}
      height={height}
      width={width}
      type="image"
      layout="responsive"
    />
  </Container>
)

export default BlogImageBlock
